const trainGridlets = angular.module('trainGridletDirectives', []);

trainGridlets.directive('trainNotificationGridletModule', function (
  $window,
  $state,
  $uibModal,
  notificationService,
  $stateParams
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/train/train-notification-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
    },
    link: function (scope) {
      const consist = $stateParams.consist;
      scope.area = '#gridletContentArea-train-notification-gridlet';
      scope.gridlet = 'train-notification-gridlet';

      scope.filterList = [
        {
          name: 'train',
          label: 'dashboard.notification-gridlet-module.train-filter',
        },
        {
          name: 'car',
          label: 'dashboard.notification-gridlet-module.car-filter',
        },
        {
          name: 'eventId',
          label: 'dashboard.notification-gridlet-module.event-filter',
        },
        {
          name: 'activated',
          label: 'dashboard.notification-gridlet-module.activated-filter',
        },
        {
          name: 'deactivated',
          label: 'dashboard.notification-gridlet-module.deactivated-filter',
        },
        {
          name: 'ack',
          label: 'dashboard.notification-gridlet-module.ack-filter',
        },
        {
          name: 'name',
          label: 'dashboard.notification-gridlet-module.name-filter',
        },
        {
          name: 'deactive',
          label: 'dashboard.notification-gridlet-module.show-deactivated',
        },
      ];

      scope.selection = {
        values: {
          train: true,
          emu: true,
          car: true,
          eventId: true,
          activated: true,
          deactivated: true,
          ack: true,
          name: true,
          deactive: false,
        },
      };

      scope.criteria = {
        skipAmount: 0,
        count: 15,
        consist: consist,
        sortType: 'activated',
        reverse: true,
        searchString: '',
        filter: 'ALL',
        searchChanged: false,
      };
    },
  };
});

trainGridlets.directive('driverViewGridletModule', function () {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/train/driver-view-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function (scope) {
      scope.useIframe = __env.profile === 'MELCO';
      scope.gridlet = 'driver-view-gridlet';
      scope.$watch('settings.fullscreen', function() {
        scope.settings = angular.copy(scope.settings);
      });
    },
  };
});
